import React from 'react';
import { history } from '../helpers/history';
import { getCurrentUser } from '../actions/authActions';
import { logoutUser } from '../actions/authActions';
import { useSelector, useDispatch } from 'react-redux';
import { ReactComponent as DashboardIcon } from '../images/icons/dashboard.svg';
import { ReactComponent as WebsiteIcon } from '../images/icons/web.svg';
import { ReactComponent as AnalyticsIcon } from '../images/icons/analyticsIcon.svg';
import { ReactComponent as DomainIcon } from '../images/icons/domainIcon.svg';
import { ReactComponent as StorageIcon } from '../images/icons/storage.svg';
import { ReactComponent as TrafficIcon } from '../images/icons/traffic.svg';
import { ReactComponent as EmailIcon } from '../images/icons/email.svg';
import { ReactComponent as CartIcon } from '../images/icons/cart.svg';
import { ReactComponent as AccountIcon } from '../images/icons/accountIcon.svg';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import logoWhite from '../images/logo-white.png';

const LogoutIcon = () =>(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#fc5a5a" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" fill="#fc5a5a"/>
  </svg>
)

function SideBar(props) {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const email = useSelector((state) => state.auth.email);
  const dispatch = useDispatch();
  const isAdmin = currentUser.role === 'admin' || email === 'scott@editpage.com';
  const homeRoute = isAdmin ? '/dashboard' : '/beta';
  const currentSection = window.location.href.split('/')[3];

  const coreItems = [
    { key: 'editor', label: 'Website', icon: <WebsiteIcon />, route: '/editor' },
    { key: 'analytics', label: 'Analytics', icon: <AnalyticsIcon />, route: '/analytics' },
    { key: 'register', label: 'Register Domain', icon: <DomainIcon />, route: '/register' },
    { key: 'storage', label: 'Storage', icon: <StorageIcon />, route: '/storage' },
    { key: 'traffic', label: 'Boost Traffic', icon: <TrafficIcon />, route: '/traffic' },
    { key: 'email', label: 'Email', icon: <EmailIcon />, route: '/email' },
    { key: 'store', label: 'Store', icon: <CartIcon />, route: '/store' },
    { key: 'account', label: 'Account', icon: <AccountIcon />, route: '/account' },
  ];

  const renderMenuItem = ({ key, label, icon, route }) => {
    const isActive = currentSection === key;

    return (
      <div
        key={key}
        className={`sidebarRow${isActive ? ' active' : ''}`}
        onClick={() => history.push(route)}
      >
        <span className="sidebarRowIcon">{icon}</span>
        <span className="sidebarRowLabel">{label}</span>
      </div>
    );
  };

  const renderLogout = () => {
    return (
      <div className="sidebarRow logout" onClick={logout}>
        <span className="sidebarRowIcon">
          <LogoutIcon />
        </span>
        <span className="sidebarRowLabel">Logout</span>
      </div>
    );
  };

  const brandClick = () => {
    history.push(homeRoute);
  };

  const logout = () => {
    dispatch(logoutUser());
    history.push('/');
  };

  React.useEffect(() => {
    dispatch(getCurrentUser({ tokenID: localStorage.getItem('token') }));
  }, [dispatch]);

  return (
    <>
      <div className="sidebar">
        <div className="sidebarBody">
          <div className="sidebarContainer">
            <div className="sidebarBrand" onClick={brandClick}>
              <img className="sidebarBrandLogo" src={logoWhite} alt="EditPage" />
            </div>

            <div className="sidebarMainMenu">
              {isAdmin
                ? renderMenuItem({
                    key: 'dashboard',
                    label: 'Dashboard',
                    icon: <DashboardIcon />,
                    route: '/dashboard',
                  })
                : ''}
              {coreItems.map(renderMenuItem)}
              {isAdmin
                ? renderMenuItem({
                    key: 'admin',
                    label: 'Admin',
                    icon: <AdminPanelSettingsIcon />,
                    route: '/admin/dashboard',
                  })
                : ''}
            </div>

            <div className="sidebarFooter">{renderLogout()}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SideBar;
